const dashboardPagePortfolioPositionsSectionCopy = {
  error: 'An error occurred while trying to load the portfolio positions. If this error continues to occur, please contact our support team.',
  loadingMessage: 'Loading...',
  sectionTitle: 'Portfolio Positions'
};

export default dashboardPagePortfolioPositionsSectionCopy;
